import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";

export const UsageMeter = ({ onUpgrade, refreshKey }) => {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    api
      .get("/company/usage")
      .then(({ data }) => setUsage(data))
      .catch(() => setUsage(null));
  }, [refreshKey]);

  if (!usage) return null;
  const full = usage.applications_remaining === 0;

  return (
    <div
      data-testid="usage-meter"
      className={`mb-8 rounded-lg border p-6 ${
        full ? "border-amber-300 bg-amber-50" : "border-slate-200 bg-white shadow-sm"
      }`}
    >
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="grid h-9 w-9 place-items-center rounded-md bg-slate-900 text-white">
            <Gauge className="h-4 w-4" />
          </span>
          <div>
            <div className="font-display text-base font-bold text-slate-900">
              {usage.plan_name} account
            </div>
            <p className="mt-1 text-sm text-slate-600" data-testid="usage-summary">
              {usage.applications_used} of {usage.applications_limit} active credit applications
              used · {usage.archived} of {usage.archived_limit_label} archived* credit
              applications · {usage.references} references collected (unlimited)
            </p>
            <p className="mt-1 text-xs text-slate-500" data-testid="usage-archive-footnote">
              * - Archived credit applications may be purged by the subscribing company as needed
            </p>
          </div>
        </div>
        {!usage.paid && (
          <Button
            onClick={onUpgrade}
            data-testid="usage-upgrade-button"
            className="rounded-full bg-blue-600 px-6 font-semibold transition-colors duration-200 hover:bg-blue-700 active:scale-95"
          >
            {full ? "Upgrade for more" : "See plans"}
          </Button>
        )}
      </div>
      <div className="mt-5 h-2 overflow-hidden rounded-full bg-slate-100">
        <div
          data-testid="usage-meter-bar"
          className={`h-full rounded-full transition-[width] duration-500 ${
            full ? "bg-amber-500" : "bg-blue-600"
          }`}
          style={{ width: `${usage.percent}%` }}
        />
      </div>
      {full && (
        <p className="mt-4 text-sm font-medium text-amber-900" data-testid="usage-full-note">
          You have used every active credit application on your {usage.plan_name} account. Archive
          one to free up space, or upgrade to Starter ($15/month plus tax when applicable, 5
          applications), Small Business ($49/month plus tax when applicable, 25 applications) or
          Professional ($99/month plus tax when applicable, 200 applications).
        </p>
      )}
    </div>
  );
};
